const PivotlistSortIcon = function(props) {
  const class_names = ['pivotlist_sort_icon', 'sorted_by_' + props.current_sort, 'default_sorted_by_' + props.default_sort];
  return <span className={class_names.join(' ')} title='Sort based on ascending or descending values.'>&nbsp;</span>;
}

export default PivotlistSortIcon;
